import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    loaded: false,
    error: null,
    /** 'student' | 'teacher' | 'all' — lo decide el servidor. */
    scope: null,
    /** El servidor confirma si este usuario puede ver tareas. */
    canViewTasks: false,
    courses: [],
    classes: [],
    tasks: [],
    serverNow: null,
};

const calendarSlice = createSlice({
    name: 'calendar',
    initialState,
    reducers: {
        setCalendarLoading: (state, { payload }) => {
            state.loading = payload;
            if (payload) state.error = null;
        },
        setCalendarData: (state, { payload }) => {
            state.loading = false;
            state.loaded = true;
            state.error = null;
            state.scope = payload.scope;
            state.canViewTasks = Boolean(payload.canViewTasks);
            state.courses = payload.courses || [];
            state.classes = payload.classes || [];
            // Blindaje: si el servidor no autoriza tareas, no se guardan.
            state.tasks = payload.canViewTasks ? (payload.tasks || []) : [];
            state.serverNow = payload.serverNow || null;
        },
        setCalendarError: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
        },
        resetCalendar: () => initialState,
    },
});

export const {
    setCalendarLoading,
    setCalendarData,
    setCalendarError,
    resetCalendar,
} = calendarSlice.actions;

export default calendarSlice.reducer;
